export const EDIT_CHART_DATA_REQUEST = "EDIT_CHART_DATA_REQUEST";
export const EDIT_CHART_DATA_SUCCESS = "EDIT_CHART_DATA_SUCCESS";
export const EDIT_CHART_DATA_FAILURE = "EDIT_CHART_DATA_FAILURE";
